// src/adminDashboard/shared/components/DataTable/BulkActionsToolbar.tsx
// Toolbar that appears when rows are selected

import { X } from 'lucide-react';
import React from 'react';

export interface BulkAction {
    label: string;
    icon?: React.ReactNode;
    onClick: (selectedRows: (string | number)[]) => void;
    variant?: 'default' | 'danger' | 'primary';
    disabled?: boolean;
}

interface BulkActionsToolbarProps {
    selectedCount: number;
    onClearSelection: () => void;
    actions?: BulkAction[];
}

const BulkActionsToolbar: React.FC<BulkActionsToolbarProps> = ({
    selectedCount,
    onClearSelection,
    actions = [],
}) => {
    return (
        <div className="bg-primary/5 border-b border-primary/20 px-4 py-3">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                    <div className="flex items-center gap-2">
                        <span className="text-sm font-medium text-slate-900">
                            {selectedCount} {selectedCount === 1 ? 'item' : 'items'} selected
                        </span>
                        <button
                            onClick={onClearSelection}
                            className="p-1 rounded hover:bg-white/50 text-slate-500 hover:text-slate-700"
                            title="Clear selection"
                        >
                            <X size={16} />
                        </button>
                    </div>

                    <div className="h-4 w-px bg-slate-300" />

                    <div className="flex items-center gap-2">
                        {actions.map((action, index) => (
                            <button
                                key={index}
                                onClick={() => action.onClick([])} // Placeholder, handled by DataTable
                                disabled={action.disabled}
                                className={`
                                    flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium
                                    transition-colors disabled:opacity-50 disabled:cursor-not-allowed
                                    ${action.variant === 'danger'
                                        ? 'bg-red-100 text-red-700 hover:bg-red-200'
                                        : 'bg-white text-slate-700 hover:bg-slate-50 border border-slate-200'
                                    }
                                `}
                            >
                                {action.icon}
                                {action.label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BulkActionsToolbar;
